import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as sanitizeHTML from "sanitize-html";

@Pipe({
  name: 'domSanitizer'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(v: string): SafeHtml {
    return sanitizeHTML(v, {
          allowedAttributes: false,
        });
  }
}
